<template>
    <div class='error'></div>
</template>
<script>
    export default {
        name: "error",
    }
</script>

<style lang='less' scoped>
    .error{
        width: 100%;
        height: 100%;
        background-image: url("../assets/404.jpg");
        background-repeat:no-repeat ;
        background-size:100% 100%;
        background-attachment: fixed;
    }
</style>